module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', {
    attrs: {
      "title": "Informações do Produto"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-5@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('title.label')) + ":")]), _vm._v("\n          " + _vm._s(_vm._f("attribute")(_vm.product.title)) + "\n        ")])])])]), _vm._v(" "), _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('ageGroup.label'),
      "columns": 6,
      "error": _vm.getErrorByProductId('ageGroup', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.ageGroup),
      expression: "product.ageGroup"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "ageGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n              Selecione\n            ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "adult"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('ageGroup.adult.label')) + "\n            ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kids"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('ageGroup.kids.label')) + "\n            ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('ageGroup.both.label')) + "\n            ")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('warrantyTime.label'),
      "columns": 6,
      "error": _vm.getErrorByProductId('warrantyTime', _vm.product.productId)
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.warrantyTime),
      expression: "product.warrantyTime"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.warrantyTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "warrantyTime", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("dias")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('brand.label'),
      "columns": 6,
      "error": _vm.getErrorByProductId('brand', _vm.product.productId)
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.brand),
      expression: "product.brand"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.brand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "brand", $event.target.value)
      }
    }
  })])])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Variações"
    }
  }, _vm._l((_vm.product.variations), function(variation) {
    return _c('variation', {
      key: variation,
      attrs: {
        "variation": variation
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04f0c0c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/Edit/Flexy/Product.vue
// module id = 2874
// module chunks = 0